import '@/styles/index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { useDoc } from './store/documentStore'
import { useUi } from './store/uiStore'

if (import.meta.env.DEV) {
  // handy for debugging and end-to-end tests
  Object.assign(window, { __folio: { useDoc, useUi } })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
